import api from '../client';

/**
 * Service pour la gestion des commandes
 */
const orderService = {
  /**
   * Récupérer la liste des commandes
   * @param {Object} params - Paramètres (status, page, limit, startDate, endDate)
   * @returns {Promise} Liste des commandes avec pagination
   */
  getOrders: async (params = {}) => {
    try {
      const response = await api.get('/orders', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Récupérer une commande par son ID
   * @param {string} id - ID de la commande
   * @returns {Promise} Données de la commande
   */
  getOrderById: async (id) => {
    try {
      const response = await api.get(`/orders/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Créer une nouvelle commande
   * @param {Object} orderData - Données de la commande
   * @returns {Promise} Commande créée
   */
  createOrder: async (orderData) => {
    try {
      const response = await api.post('/orders', orderData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Mettre à jour le statut d'une commande
   * @param {string} id - ID de la commande
   * @param {string} status - Nouveau statut (pending, processing, shipped, delivered, cancelled)
   * @returns {Promise} Commande mise à jour
   */
  updateStatus: async (id, status) => {
    try {
      const response = await api.patch(`/orders/${id}/status`, { status });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Mettre à jour le statut de paiement
   * @param {string} id - ID de la commande
   * @param {string} paymentStatus - Nouveau statut (pending, paid, failed, refunded)
   * @returns {Promise} Commande mise à jour
   */
  updatePaymentStatus: async (id, paymentStatus) => {
    try {
      const response = await api.patch(`/orders/${id}/payment-status`, { paymentStatus });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Annuler une commande
   * @param {string} id - ID de la commande
   * @param {string} reason - Raison de l'annulation
   * @returns {Promise} Commande annulée
   */
  cancelOrder: async (id, reason) => {
    try {
      const response = await api.post(`/orders/${id}/cancel`, { reason });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Récupérer les statistiques des commandes
   * @param {Object} params - Paramètres (startDate, endDate)
   * @returns {Promise} Statistiques
   */
  getOrderStats: async (params = {}) => {
    try {
      const response = await api.get('/orders/stats', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default orderService;
